import React from 'react';
import { motion } from 'framer-motion';

const Industries = () => {
  const industries = [
    {
      icon: '🎓',
      title: 'Education',
      description: 'Student management, enrollment automation, learning analytics, academic reporting, institutional data warehousing',
    },
    {
      icon: '🏛️',
      title: 'Government',
      description: 'Citizen services portals, permit management, compliance tracking, interdepartmental workflows, open data initiatives',
    },
    {
      icon: '📦',
      title: 'Logistics & Supply Chain',
      description: 'Inventory management, shipment tracking, warehouse operations, supply chain analytics, demand forecasting',
    },
    {
      icon: '🏥',
      title: 'Healthcare',
      description: 'Patient intake, appointment scheduling, clinical workflows, healthcare analytics, population health insights',
    },
    {
      icon: '💳',
      title: 'Financial Services',
      description: 'Client onboarding, KYC automation, portfolio reporting, regulatory compliance, risk analytics, fraud detection',
    },
    {
      icon: '⚡',
      title: 'Energy & Utilities',
      description: 'Asset management, field service automation, IoT data processing, consumption analytics, predictive maintenance',
    },
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="industries-page">
      <section className="py-24">
        <div className="max-w-[1200px] mx-auto px-6">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold font-manrope mb-6">
              Industries We <span className="text-primary">Serve</span>
            </h1>
            <p className="text-muted-foreground text-lg max-w-3xl mx-auto leading-relaxed">
              Our expertise spans multiple industries, delivering solutions that address sector-specific challenges and data needs.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industries.map((industry, index) => (
              <motion.div
                key={index}
                className="bg-card p-8 rounded-2xl border border-border hover:border-primary transition-all duration-300 text-center group"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -8 }}
              >
                <div className="text-5xl mb-4 group-hover:scale-110 transition-transform">{industry.icon}</div>
                <h3 className="text-xl font-bold font-manrope mb-3">{industry.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{industry.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;